/**
 * 图片工具函数
 * 处理图片URL，添加基础路径前缀
 */

/** 图片访问基础路径 */
export const IMAGE_BASE_URL = 'https://www.hezou.top'

/**
 * 获取完整的图片URL
 * 如果图片URL已经是完整路径（包含 http:// 或 https://），直接返回
 * 否则拼接基础路径
 * @param {string} url 图片URL（相对或绝对）
 * @returns {string} 完整的图片URL
 */
export function getImageUrl(url) {
  if (!url) return ''
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }
  return IMAGE_BASE_URL + url
}

/**
 * 判断图片URL是否为完整路径
 * @param {string} url 图片URL
 * @returns {boolean}
 */
export function isFullImageUrl(url) {
  return url ? url.startsWith('http://') || url.startsWith('https://') : false
}

/**
 * 文件上传到第三方存储
 * @param {File} file 文件对象
 * @param {string} path 上传路径，默认 stack/2026
 */
export function uploadFile(file, path = 'stack/2026') {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('path', path)

  return fetch('https://www.hezou.top/hezou/file/upload', {
    method: 'POST',
    body: formData
  }).then(res => res.json())
}